import {
  DownloadOutlined,
  UploadOutlined,
  SaveOutlined,
  CopyOutlined,
  ExclamationCircleOutlined,
  InboxOutlined,
} from "@ant-design/icons";
import { Col, Collapse, Row, Select, Modal, Spin, Upload } from "antd";
import { useFormik } from "formik";
import { get, isEmpty, toLower, indexOf } from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../../components/functional_components/Button/PFButton";
import Filter from "../../../../components/functional_components/Filter/Filter";
import SummaryTable from "./Table/SummaryTable";
import SummaryTotalTable from "./Table/SummaryTotalTable";
import TotalTable from "./Table/TotalTable";
import WPTable from "./Table/WPTable";
import { setFilters } from "../../../../redux/ducks/Filters";
import { setLoading } from "../../../../redux/ducks/Loading";
import CostEstimation from "../../../../services/api/CostEstimation";
import ProjectEstimate from "../../../../services/api/ProjectEstimate";
import { fileFormatXextension, langDate } from "../../../../utils/properties";
import { buildQueryString, exportFile, showError, showSuccess, trimData } from "../../../../utils/utilities";
import { resetForm } from "../../../../redux/ducks/EditableTable";
import { setRefreshCostEstimation, setRefreshTotals } from "../../../../redux/ducks/ProjectEstimate";
import dayjs from "dayjs";
import VopTable from "./Table/VopTable";

const { Option } = Select;
const { confirm } = Modal;
const { Dragger } = Upload;

const costEstimation = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const currentDate = dayjs().format("YYYY");
  const filters = useSelector((state) => state.FiltersDuck.filters);
  const refreshCostEstimation = useSelector((state) => state.ProjectEstimateDuck.refreshCostEstimation);
  const currentLanguage = useSelector((state) => get(state.languageDuck, "currentLanguage", "GB"));
  const userInfo = useSelector((state) => get(state.userInfoDuck, "userInfo", {}));

  const [state, setState] = useState({
    data: [],
    statusListFilter: [],
    loading: false,
    modalIsVisible: false,
    uploadModal: { visible: false, wpId: "" },
    activePanel: [],
    dataContentPanel: [],
    dataContentTotal: [],
    dataContentVop: [],
    listPreventive: [],
    workPackageList: [],
    listClient: [],
    alert: false,
    selectedWP: null,
    fileList: [],
  });

  useEffect(() => {
    if (refreshCostEstimation === null) {
      const queryString = buildQueryString({}, { year: currentDate, allPages: true });
      dispatch(setFilters(queryString));
      dataList(queryString.string);
    } else if (refreshCostEstimation === true) {
      initWpData();
    }
  }, [refreshCostEstimation]);

  const initWpData = async () => {
    const wpData = await getWpData(state.activePanel);
    const tableVop = await CostEstimation.costEstimationWorkPackageVop(props.id, state.activePanel, filters.obj.year);
    setState((prevState) => ({
      ...prevState,
      dataContentPanel: get(wpData.workPackageTable, "data.costEstimationKickoffValueView", []),
      dataContentTotal: [get(wpData.workPackageTableTotal, "data", [])],
      dataContentVop: [get(tableVop, "data.columnValueMap", {})],
    }));
    dispatch(setRefreshCostEstimation(false));
    dispatch(setRefreshTotals(true));
  };

  const dataList = async (queryString) => {
    dispatch(setLoading(true));
    const workPackage = await ProjectEstimate.projectEstimateWorkPackage(props.id, queryString);
    if (!workPackage.error) setState((prevState) => ({ ...prevState, data: workPackage }));
    else showError(get(workPackage, "error.messageCode", "ER000"));
    dispatch(setLoading(false));
  };

  const resetFilter = () => {
    const queryString = buildQueryString(filters.obj, { year: currentDate });
    dispatch(setFilters(queryString));
    dataList(queryString.string);
    setState((prevState) => ({ ...prevState, activePanel: [] }));
  };

  const handleDownload = (type, id) => async () => {
    setState((prevState) => ({ ...prevState, loading: true }));
    let file = null;
    if (type === "summary") {
      file = await CostEstimation.projectEstimateWorkPackageTableDownloadSummary(props.id, filters.obj.year);
    } else {
      file = await CostEstimation.projectEstimateWorkPackageTableDownloadWP(props.id, id, filters.obj.year);
    }
    if (!file.error) {
      const blob = new Blob([file]);
      exportFile(blob, `${type !== "summary" ? type + "_" : type}${id ? id : ""}.csv`);
      showSuccess();
    } else {
      showError(get(file, "error.messageCode", "ER000"));
    }
    setState((prevState) => ({ ...prevState, loading: false }));
  };

  const searchFromClient = async (value) => {
    formikCopy.setFieldValue("client", value);
    let preventive = [];
    let queryString = "";
    if (value !== undefined && value !== null && value !== "") {
      formikCopy.setFieldValue("preventiveX", "");
      formikCopy.setFieldValue("workpackage", "");
      queryString = `associated=true&clientId=${value}`;
    } else {
      queryString = `allPages=true`;
    }
    preventive = await ProjectEstimate.projectEstimateList(queryString);
    if (preventive.error) {
      showError(get(preventive, "error.messageCode", "ER000"));
    }
    setState((prevState) => ({
      ...prevState,
      listPreventive: get(preventive, "data", []),
    }));
  };

  const searchFromPreventive = async (value) => {
    formikCopy.setFieldValue("preventiveX", value);
    let wp = [];
    if (value !== undefined && value !== null && value !== "") {
      wp = await ProjectEstimate.projectEstimateWorkPackage(value, "allPages=true");
      if (wp.error) {
        showError(get(wp, "error.messageCode", "ER000"));
      }
      setState((prevState) => ({
        ...prevState,
        workPackageList: get(wp, "data", []),
      }));
    }
  };

  const getClients = (wp) => async () => {
    const client = await ProjectEstimate.clientsProjectEstimate("allPages=true");
    const preventive = await ProjectEstimate.projectEstimateList("allPages=true");
    setState((prevState) => ({
      ...prevState,
      selectedWP: wp,
      listClient: get(client, "data", []),
      listPreventive: get(preventive, "data", []),
      modalIsVisible: true,
    }));
  };

  const handleCloseCopy = async () => {
    formikCopy.resetForm();
    setState((prevState) => ({
      ...prevState,
      modalIsVisible: false,
    }));
  };

  const formikDocument = useFormik({
    initialValues: {
      file: "",
    },
    validate: (values) => {
      let errors = {};
      if (!values.file) {
        // file is required only on new, in edit I cannot upload file and edit only description
        errors.file = "Required!";
      }
      return errors;
    },
    enableReinitialize: true,
    onSubmit: async () => {
      if (!isEmpty(state.fileList)) {
        dispatch(setLoading(true));
        const formData = new FormData();
        state.fileList.forEach((file) => {
          formData.append("file", file);
        });
        setState((prevState) => ({ ...prevState, loading: true }));
        const response = await ProjectEstimate.uploadProjectEstimate(
          props.id,
          state.uploadModal.wpId,
          filters.obj.year,
          formData
        );
        if (!response.error) {
          const queryString = buildQueryString(filters.obj, { year: currentDate });
          dispatch(setFilters(queryString));
          const wpData = await getWpData(state.uploadModal.wpId);
          setState((prevState) => ({
            ...prevState,
            dataContentPanel: get(wpData.workPackageTable, "data.costEstimationKickoffValueView", []),
            dataContentTotal: [get(wpData.workPackageTableTotal, "data", [])],
          }));
          closeUploadModal();
          showSuccess();
        } else {
          showError(get(response, "error.messageCode", "ER000"));
        }
        setState((prevState) => ({ ...prevState, loading: false, fileList: [] }));
        dispatch(setLoading(false));
      }
    },
  });

  const propsFile = {
    multiple: false,
    onRemove: (file) => {
      const index = state.fileList.indexOf(file);
      const newFileList = state.fileList.slice();
      newFileList.splice(index, 1);
      setState((prevState) => ({
        ...prevState,
        fileList: newFileList,
      }));
      formikDocument.setFieldValue("file", "");
    },
    beforeUpload: (file) => {
      let ckFileList = [];
      let ckFileValue = "";
      if (indexOf(fileFormatXextension["csv"], file.type) !== -1) {
        ((ckFileList = [file]), (ckFileValue = "ok"));
      } else {
        showError(t("projectEstimate.modal.errorFileFormat"));
      }
      setState((prevState) => ({
        ...prevState,
        fileList: ckFileList,
      }));
      formikDocument.setFieldValue("file", ckFileValue);
      return false;
    },
    fileList: state.fileList,
  };

  const openUploadModal = (wpId) => () => {
    setState((prevState) => ({
      ...prevState,
      uploadModal: { visible: true, wpId },
    }));
  };

  const closeUploadModal = () => {
    formikDocument.resetForm();
    setState((prevState) => ({
      ...prevState,
      uploadModal: { visible: false, wpId: "" },
      fileList: [],
    }));
  };

  const getWpData = async (key) => {
    let workPackageTable = {};
    let workPackageTableTotal = {};
    workPackageTable = await CostEstimation.projectEstimateWorkPackageTableWP(props.id, key, filters.obj.year);
    if (!workPackageTable.error && workPackageTable.data) {
      workPackageTable.data.costEstimationKickoffValueView.forEach((wp, i) => {
        wp.key = `wp-${i}`; // This is necessary to remove warning in console for unique key row
      });
    } else {
      showError(get(workPackageTable, "error.messageCode", "ER000"));
    }

    // total data
    workPackageTableTotal = await CostEstimation.projectEstimateWorkPackageTableTotalWP(
      props.id,
      key,
      filters.obj.year
    );
    if (!workPackageTableTotal.error && workPackageTableTotal.data) {
      workPackageTableTotal.data.key = "wp-total"; // This is necessary to remove warning in console for unique key row
    } else {
      showError(get(workPackageTableTotal, "error.messageCode", "ER000"));
    }
    return { workPackageTable, workPackageTableTotal };
  };

  const onChangeCollapse = async (key) => {
    if (!key) return;
    key = key[0];
    dispatch(resetForm()); // Init values of editable table
    dispatch(setLoading(true));
    setState((prevState) => ({ ...prevState, activePanel: key }));
    let workPackageTable = {};
    let workPackageTableTotal = {};
    let tableVop = {};
    if (!isEmpty(key)) {
      if (key === "summary") {
        // summary data
        workPackageTable = await CostEstimation.projectEstimateWorkPackageTableSummary(props.id, filters.obj.year);
        if (!workPackageTable.error && workPackageTable.data) {
          workPackageTable.data.costEstimationKickoffValueView.forEach((wp, i) => {
            wp.key = `summary-${i}`; // This is necessary to remove warning in console for unique key row
          });
        } else {
          showError(get(workPackageTable, "error.messageCode", "ER000"));
        }

        // total data
        workPackageTableTotal = await CostEstimation.projectEstimateWorkPackageTableTotalSummary(
          props.id,
          filters.obj.year
        );
        if (!workPackageTableTotal.error && workPackageTableTotal.data) {
          workPackageTableTotal.data.key = "sumary-total"; // This is necessary to remove warning in console for unique key row
        } else {
          showError(get(workPackageTableTotal, "error.messageCode", "ER000"));
        }

        // vop data
        tableVop = await CostEstimation.costEstimationSummaryVop(props.id, filters.obj.year);
        if (tableVop.error) {
          showError(get(tableVop, "error.messageCode", "ER000"));
        }
      } else if (key === "summaryWip") {
        // summary data
        workPackageTable = await CostEstimation.projectEstimateWorkPackageTableSummaryWip(props.id, filters.obj.year);
        if (!workPackageTable.error && workPackageTable.data) {
          workPackageTable.data.costEstimationKickoffValueView.forEach((wp, i) => {
            wp.key = `summary-wip-${i}`; // This is necessary to remove warning in console for unique key row
          });
        } else {
          showError(get(workPackageTable, "error.messageCode", "ER000"));
        }

        // total data
        workPackageTableTotal = await CostEstimation.projectEstimateWorkPackageTableTotalSummaryWip(
          props.id,
          filters.obj.year
        );
        if (!workPackageTableTotal.error && workPackageTableTotal.data) {
          workPackageTableTotal.data.key = "sumary-wip-total"; // This is necessary to remove warning in console for unique key row
        } else {
          showError(get(workPackageTableTotal, "error.messageCode", "ER000"));
        }
        // vop data
        tableVop = await CostEstimation.costEstimationSummaryWipVop(props.id, filters.obj.year);
        if (tableVop.error) {
          showError(get(tableVop, "error.messageCode", "ER000"));
        }
      } else {
        // WP data
        const wpData = await getWpData(key);
        workPackageTable = wpData.workPackageTable;
        workPackageTableTotal = wpData.workPackageTableTotal;

        // vop data
        tableVop = await CostEstimation.costEstimationWorkPackageVop(props.id, key, filters.obj.year);
        if (tableVop.error) {
          showError(get(tableVop, "error.messageCode", "ER000"));
        }
      }
    }
    setState((prevState) => ({
      ...prevState,
      dataContentPanel: get(workPackageTable, "data.costEstimationKickoffValueView", []),
      dataContentTotal: [get(workPackageTableTotal, "data", [])],
      dataContentVop: [get(tableVop, "data.columnValueMap", [])],
    }));

    dispatch(setLoading(false));
  };

  const formikCopy = useFormik({
    initialValues: {
      client: null,
      preventiveX: null,
      workpackage: null,
    },
    validate: (values) => {
      let errors = {};
      if (!values.workpackage) {
        errors.workpackage = "Required!";
      }
      if (!values.preventiveX) {
        errors.preventiveX = "Required!";
      }
      return errors;
    },
    onSubmit: (values) => {
      confirm({
        title: t("projectEstimate.detail.tabs.costEstimation.modal.copy"),
        icon: <ExclamationCircleOutlined />,
        onOk: async () => {
          dispatch(setLoading(true));
          dispatch(resetForm());
          const copyWP = await CostEstimation.projectEstimateWorkPackageCopy(
            props.id,
            state.selectedWP,
            `${values.workpackage}`
          );
          if (copyWP.error) showError(get(copyWP, "error.messageCode", "ER000"));
          const wpData = await getWpData(state.selectedWP);
          setState((prevState) => ({
            ...prevState,
            dataContentPanel: get(wpData.workPackageTable, "data.costEstimationKickoffValueView", []),
            dataContentTotal: [get(wpData.workPackageTableTotal, "data", [])],
            modalIsVisible: false,
          }));
          formikCopy.values.client = null;
          formikCopy.values.preventiveX = null;
          formikCopy.values.workpackage = null;
          dispatch(setLoading(false));
        },
        onCancel() {},
      });
    },
  });

  const formikFilter = useFormik({
    initialValues: {
      year: dayjs(currentDate, "YYYY"),
    },
    validate: (values) => {
      values = trimData(values);
      let errors = {};
      if (!values.year) {
        errors.year = "Required!";
      }
      return errors;
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      const queryString = buildQueryString(filters.obj, {
        year: dayjs(values.year, "YYYY").format("YYYY"),
      });
      dataList(queryString.string);
      dispatch(setFilters(queryString));
      setState((prevState) => ({ ...prevState, activePanel: [] }));
    },
  });

  const fieldsFilter = [
    {
      type: "year",
      isRequired: true,
      id: "year",
      name: "year",
      format: "YYYY",
      locale: langDate[`locale_${toLower(currentLanguage)}`],
      label: t("projectEstimate.filter.year"),
      value: formikFilter.values.year,
      onChange: (date) => {
        formikFilter.setFieldValue("year", date);
      },
    },
  ];

  const renderSummaryContent = (isWip = false) => {
    return (
      <>
        {!isWip && (
          <Row type="flex" align="middle" justify="end" className="mb-10">
            <Button
              isLoading={state.loading}
              currentIcon={<DownloadOutlined className="icon-medium" />}
              clickCallback={handleDownload("summary")}
            />
          </Row>
        )}
        <SummaryTable
          isWip={isWip}
          dataContentSummary={state.dataContentPanel}
          id={props.id}
          whereIam={"costEstimation"}
        />
        <SummaryTotalTable dataContentTotal={state.dataContentTotal} id={props.id} />
        {!isEmpty(state.dataContentVop) && <VopTable vopData={state.dataContentVop} />}
      </>
    );
  };

  const renderWpContent = (item) => {
    return (
      <>
        <Row type="flex" align="middle" justify="end" className="mb-10" span={12}>
          <Button
            isLoading={state.loading}
            currentIcon={<DownloadOutlined className="icon-medium" />}
            clickCallback={handleDownload("wp", item.id)}
          />
          {item.status !== "RELEASED" && (
            <>
              <Button
                isDisabled={!userInfo.canEditCostEstimation}
                className="ml-10"
                currentIcon={<CopyOutlined className="icon-medium" />}
                clickCallback={getClients(item.id)}
              />
              <Button
                isDisabled={!userInfo.canEditCostEstimation}
                className="ml-10"
                currentIcon={<UploadOutlined className="icon-medium" />}
                clickCallback={openUploadModal(item.id)}
              />
            </>
          )}
        </Row>
        <Row>
          <WPTable
            dataContentWP={state.dataContentPanel}
            projectId={props.id}
            WpId={item.id}
            status={item.status}
            type="cost-estimation"
          />
          <TotalTable dataContentTotal={state.dataContentTotal} id={props.id} />
          {!isEmpty(state.dataContentVop) && <VopTable vopData={state.dataContentVop} />}
        </Row>
      </>
    );
  };

  const items = [
    {
      key: "summary",
      label: t("projectEstimate.detail.tabs.costEstimation.summary"),
      className: "mb-1em",
      children: renderSummaryContent(),
    },
    {
      key: "summaryWip",
      label: t("projectEstimate.detail.tabs.costEstimation.summaryWip"),
      className: "mb-1em",
      children: renderSummaryContent(true),
    },
    ...(state.data.data && state.data.data.length > 0
      ? state.data.data.map((item) => ({
          key: item.id,
          label: `WP${item.counter} | ${item.name} | ${item.status}`,
          className: "mb-1em",
          children: renderWpContent(item),
        }))
      : []),
  ];

  return (
    <>
      <Filter formikForm={formikFilter} fields={fieldsFilter} allInOneRow={false} onReset={resetFilter} />

      <Collapse items={items} accordion activeKey={state.activePanel} onChange={onChangeCollapse} destroyOnHidden />

      <Modal
        width={500}
        title={<b>{t("projectEstimate.detail.tabs.costEstimation.modal.title")}</b>}
        open={state.modalIsVisible}
        onCancel={handleCloseCopy}
        footer={[
          <Button
            key="okButton"
            currentIcon={<SaveOutlined className="icon-medium" />}
            clickCallback={formikCopy.submitForm}
            isDisabled={!(formikCopy.isValid && formikCopy.dirty)}
          />,
        ]}
      >
        <Row type="flex" align="middle" justify="center" className="mb-10">
          <Col lg={24} md={24} xs={24} sm={24}>
            <Row>
              <label className="fw-bold mt-10" htmlFor="client">
                {t("projectEstimate.detail.tabs.costEstimation.modal.client")}
              </label>
            </Row>
            <Row>
              <Select
                allowClear
                id="client"
                name="client"
                className="w-100"
                placeholder={t("projectEstimate.detail.tabs.costEstimation.modal.client")}
                onChange={searchFromClient}
                onBlur={formikCopy.handleBlur("client")}
                value={formikCopy.values.client}
              >
                {state.listClient.map((item) => (
                  <Option key={item.id} value={item.id}>
                    {item.name}
                  </Option>
                ))}
              </Select>
            </Row>
          </Col>
        </Row>
        <Row type="flex" align="middle" justify="center" className="mb-10">
          <Col lg={24} md={24} xs={24} sm={24}>
            <Row>
              <label className="fw-bold mt-10" htmlFor="preventiveX">
                {t("projectEstimate.detail.tabs.costEstimation.modal.preventive")}*
              </label>
            </Row>
            <Row>
              <Select
                id="preventiveX"
                name="preventiveX"
                className="w-100"
                placeholder={t("projectEstimate.detail.tabs.costEstimation.modal.preventive")}
                onChange={searchFromPreventive}
                onBlur={formikCopy.handleBlur("preventiveX")}
                value={formikCopy.values.preventiveX}
              >
                {state.listPreventive.map((item) => (
                  <Option key={item.id} value={item.id}>
                    {item.id} | {item.description}
                  </Option>
                ))}
              </Select>
            </Row>
          </Col>
        </Row>
        <Row type="flex" align="middle" justify="center" className="mb-10">
          <Col lg={24} md={24} xs={24} sm={24}>
            <Row>
              <label className="fw-bold mt-10" htmlFor="workpackage">
                {t("projectEstimate.detail.tabs.costEstimation.modal.workpackage")}*
              </label>
            </Row>
            <Row>
              <Select
                disabled={!(formikCopy.values.client || formikCopy.values.preventiveX)}
                id="workpackage"
                name="workpackage"
                className="w-100"
                placeholder={t("projectEstimate.detail.tabs.costEstimation.modal.workpackage")}
                onChange={formikCopy.handleChange("workpackage")}
                onBlur={formikCopy.handleBlur("workpackage")}
                value={formikCopy.values.workpackage}
              >
                {state.workPackageList.map((item) => (
                  <Option key={item.id} value={String(item.id)}>
                    {`WP${item.counter} | ${item.name}`}
                  </Option>
                ))}
              </Select>
            </Row>
          </Col>
        </Row>
      </Modal>
      <Modal
        width={700}
        title={<b>{t("projectEstimate.detail.tabs.preventiveForm.titleNewDocument")}</b>}
        open={state.uploadModal.visible}
        onCancel={closeUploadModal}
        footer={[
          <Button
            isLoading={state.loading}
            key="okButton"
            currentIcon={<SaveOutlined className="icon-medium" />}
            clickCallback={formikDocument.submitForm}
            isDisabled={!(formikDocument.dirty && formikDocument.isValid)}
          />,
        ]}
      >
        {state.loading ? (
          <div className="container-spinner-positioning">
            <Spin spinning={state.loading} className="spinner-positioning" />
          </div>
        ) : (
          ""
        )}
        <Row gutter={[40, 48]}>
          <Col span={24}>
            <Row type="flex" justify="center" align="center" className="mt-1em mb-10">
              <Col span={24}>
                <p>{t("projectEstimate.modal.allowedExtensions")} .csv</p>
              </Col>
              <Col span={24}>
                <Dragger {...propsFile}>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">{t("projectEstimate.detail.tabs.preventiveForm.uploadText")}</p>
                </Dragger>
              </Col>
            </Row>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default costEstimation;
